import { useContext } from 'react'

import { AssistantChatMessagesContext } from '../providers'

export function useAssistantChatMessagesContext() {
  const context = useContext(AssistantChatMessagesContext)

  if (!context) {
    throw new Error(
      'useAssistantChatMessagesContext must be used within AssistantChatMessagesContext',
    )
  }

  return context
}
